<template lang="html">
    <div class="schema-editor">

        <Ace
            v-model="content"
            :key="value.selectedModelUid + readOnly"
            @init="editorInit"
            :class="{'is-read-only': true /* l'éditeur est désactiver pour le moment */ }"
            lang="yaml"
            theme="tomorrow_night"
            width="100%"
            ref="ace"
        ></Ace>

        <no-selected-model-comp
            v-if="!selectedModel"
            :display="!content"
            :read-only="readOnly"
            :selected-model="selectedModel"
        ></no-selected-model-comp>
        <!-- A garder car hasUnsavedChange devra être opérationnel pour une prochaine release  -->
<!--         <div
            v-if="hasUnsavedChange"
            style="position: absolute; z-index: 5; width: 40px; height: 40px; background: red;"
        ></div> -->
    </div>
</template>
<script>
import Ace from 'vue2-ace-editor';
import YAML from 'yaml';
import NoSelectedModelComp from '../no-selected-model-composant.vue';
import { mapGetters } from 'vuex';
import * as acemodule from 'ace-builds/src-noconflict/ace';
import { isEqual } from 'lodash';
export default {
    name: 'SchemaEditor',
    components: {
        Ace,
        NoSelectedModelComp,
    },
    props: {
        value: {    // <-- shemaModelisation
            required: true
        },
        height: {
            type: Number,
            default: 500
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            content: '',
        };
    },
    computed: {
        ...mapGetters([
            'listRelDatatype'
        ]),
        selectedModel (){
            return this.value.selectedModel !== undefined;
        },
        modelList (){
            if(Object.keys(this.value).length === 0) return {};
            return this.value.manifest.data_modeling.models;
        },
    },

    watch: {
        'value.selectedModel':{
            handler (newVal){
                if(newVal){
                    this.setContent();
                }
            },
            deep: true,
        },

        readOnly (){
            this.setContent();
        },

        content (val){
            this.$refs.ace.editor.getSession().clearAnnotations();
            if (YAML.stringify(this.parseObject(this.value.selectedModel)) !== val) {
                try {
                    this.lintYaml(val, false);
                    YAML.parse(val);
                    this.$emit('removeModelFromChanges', this.value.selectedModel.name);
                }
                catch (e) {
                    this.$emit('addModelToChanges', this.value.selectedModel.name);
                }
            }
            else {
                this.$emit('removeModelFromChanges', this.value.selectedModel.name);
            }
        },
    },

    mounted() {
        this.setContent();
    },
    methods: {
        correctSyntaxAndSave(showErrors = true) {
            if (this.value.selectedModel) {
                try{
                    this.value.schemaHasError = false;
                    this.lintYaml(this.content, showErrors);
                    let content = YAML.parse(this.content);
                    this.value.updateModel(content);
                    this.$emit('removeModelFromChanges', this.value.selectedModel.name);
                    if(showErrors){
                        this.$store.commit('SET_SNACKBAR', {
                            color: 'success',
                            icon: 'done',
                            text: this.$t('instance.data_model.schema_editor.index.no_error'),
                        });
                        this.$store.commit('SET_DISPLAY_SNACKBAR', true);
                    }
                }catch(e){
                    // if e === object is a error throw by YAML lib
                    if(typeof e === 'object'){
                        this.value.schemaHasError = true;
                        this.$refs.ace.editor.getSession().setAnnotations([
                            this.createAnnotationError(0, `"${e.name}": ${e.message}`)
                        ]);
                    }
                }
            }

        },
        getContent () {
            return YAML.parse(this.content);
        },
        parseObject(data) {
            let content = JSON.parse(JSON.stringify(data));
            delete content.uid;
            for (var i = content.fields.length - 1; i >= 0; i--) {
                let f = content.fields[i];
                if(f.hasOwnProperty('attributes') &&
                   f.attributes !== null &&
                   f.attributes.hasOwnProperty('to')
                ){
                    f.attributes.to = f.attributes.to.name;
                }
            }
            return content;
        },
        setContent (){
            if(!this.value.selectedModel) return;
            this.content = YAML.stringify(this.parseObject(this.value.selectedModel));
        },
        editorInit(editor) {
            require('brace/ext/language_tools'); // language extension prerequsite...
            require('brace/mode/yaml');
            require('brace/theme/tomorrow_night');
            require('brace/snippets/javascript'); // snippet
            editor.setOptions({
                enableBasicAutocompletion: false,
                enableSnippets: false,
                enableLiveAutocompletion: false,
                tabSize: 2,
                readOnly: true //this.readOnly -- pour le moment on disable l'editeur de texte
            });


            let schema = this.value;
            let wordList = schema.modelList.map((model) => model.name);
            var staticWordCompleter = {
                getCompletions: function(editor, session, pos, prefix, callback) {
                    callback(null, wordList.map(function(word) {
                        return {
                            caption: word,
                            value: word,
                            meta: 'model'
                        };
                    }));

                }
            };

            editor.completers = [staticWordCompleter];
            editor.getSession().selection.on('changeCursor', () => {
                let _editor = this.$refs.ace.editor;
                let row = _editor.getCursorPosition().row;
                let text = _editor.session.getLine(row);
                let relRegex = /\s?to\s?:\s?[\w?]+?/;
                if(wordList.includes(_editor.getCopyText())) return;
                if(text.match(relRegex)){
                    // let i = text.indexOf(':');
                    // _editor.selection.setRange({
                    //     start: {
                    //         row: row,
                    //         column: i+2,
                    //     },
                    //     end: {
                    //         row: row,
                    //         column: text.length,
                    //     },
                    // });
                    let Autocomplete = acemodule.acequire('ace/autocomplete').Autocomplete;
                    if(!_editor.completer){
                        _editor.completer = new Autocomplete(_editor);
                    }
                    _editor.completers = [staticWordCompleter];
                    _editor.completer.showPopup(_editor);
                }
            });
            editor.commands.addCommand({
                name: 'save',
                bindKey: {
                    win: 'Ctrl-S',
                    mac: 'Command-S',
                },
                exec: this.triggerSave
            });
        },

        triggerSave() {
            if (!this.value.schemaHasError) {
                this.correctSyntaxAndSave();
                this.$emit('save');
            }
        },

        lintYaml (content, showErrors = true){
            this.$refs.ace.editor.getSession().clearAnnotations();
            this.value.resetModelStructureError();
            let yamlPerLine = content.split('\n');
            let fields = [];
            let origin = [];
            let fieldCount = -1;
            for (let i = 0; i < yamlPerLine.length; i++) {
                // est ce que la ligne commence par au moin un espace
                if (yamlPerLine[i].match(/^\s+/g)) {
                    // est ce que la ligne commence par au moin un espace suivi par le char '-'
                    if (yamlPerLine[i].match(/^\s+\-/g)) {
                        fieldCount++;
                        fields.push({
                            val: yamlPerLine[i],
                            line: i,
                            content: [],
                        });
                    } else {
                        fields[fieldCount].content.push({
                            val: yamlPerLine[i],
                            line: i,
                        });
                    }
                } else {
                    origin.push({
                        val: yamlPerLine[i],
                        line: i
                    });
                }
            }
            let errors = [];
            let originValues = origin.map((item) => item.val).join(' ');
            if(!originValues.includes('fields')){
                errors.push(this.createAnnotationError(0, 'Model must have a key "fields".'));
            }
            if (!originValues.includes('name')) {
                if (errors.length === 0) {
                    errors.push(this.createAnnotationError(0,  'Model must have a key "name".'));
                } else {
                    errors[0].text += '\nModel must have a key "name"';
                }
            }
            try{
                let parsed = YAML.parse(this.content);
                let representationFieldError = false;
                if(parsed.hasOwnProperty('representation_field') && parsed.representation_field !== ''){
                    for(let field of parsed.fields){
                        if(field.name !== parsed.representation_field){
                            representationFieldError = true;
                        }else{
                            representationFieldError = false;
                            break;
                        }
                    }
                }
                if(representationFieldError){
                    errors.push(this.createAnnotationError(0,  '"representation_field" must be the name of a field from the model.'));
                }
            }catch(e){
                console.error(e);
            }
            for (let field of fields) {
                let content = field.val;
                content += field.content.map((fc) => fc.val);
                if (!content.includes('datatype')) {
                    errors.push(this.createAnnotationError(field.line, 'Field must have a key "datatype".'));
                    if (!content.includes('name')) {
                        errors[errors.length - 1].text += '\nField must have a key "name".';
                    }
                }else{
                    if (!content.includes('name')) {
                        errors.push(this.createAnnotationError(field.line, 'Field must have a key "name".'));
                    }
                }
            }
            if (showErrors) {
                this.$refs.ace.editor.getSession().setAnnotations(errors);
            }
            this.value.schemaHasError = errors.length > 0;
            for(let error of errors){
                this.value.addModelStructureError(error);
            }
            if(errors.length > 0){
                throw 'Structure error';
            }
        },

        createAnnotationError (row, message){
            return {
                row: row,
                column: 0,
                text: message,
                type: 'error',
            };
        }
    },
};

</script>
<style lang="scss">
// $default-ace-tag-color: #CC6666;
$default-ace-text-color: #8a8787;
.schema-editor {
    display: inline-block;
    position: relative;
    vertical-align: top;
    width: 40%;

    .no-selected-model{
        position: absolute !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }

    .ace_editor {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .is-read-only{
        .ace_content{
            cursor: not-allowed;
        }
        .ace_line, .ace_keyword, .ace_meta.ace_tag {
            color: darken( $default-ace-text-color, 5% ) !important;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/SchemaEditor/index.vue